module.exports = "<p>\n  user-detail works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/user-detail/user-detail.component.html
// module id = ./src/app/users/user-detail/user-detail.component.html
// module chunks = main